module.exports = __webpack_public_path__ + "static/media/mahlzeit_cta_icon.dc311df7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mahlzeit_cta_icon.svg
// module id = 138
// module chunks = 0